import React from 'react';

import { useSxpContext } from '@futrli/predict';

import { AppNavbarSecondary } from '../../app/components/app-navbar-secondary/app-navbar-secondary';

export const OnboardingNavbar = () => {
  const { displayGlobalNav } = useSxpContext();

  return <AppNavbarSecondary displayGlobalNav={displayGlobalNav} />;
};
